<template>
  <div class="field-of-fields">
    <!-- {{user}} -->
    <h2>{{ user.first_name }} {{ user.last_name }}</h2>
    <hr style="margin-bottom: 0;" />
    <DetailSectionRowLayout
      :modelData="user"
      labelKey="labelDetail"
      :listFields="$store.getters.familyInformationListFields"
      :listExcludeFields="['first_name', 'last_name']"
    >
      <template slot="children">
        <hr />
        <h3 style="">Children</h3>
        <div v-for="(children, index) of user.children" :key="'ref' + index">
          <hr class="ref-separator" />
          <h5 style="font-weight: 600; margin-bottom: 0;">
            {{ children.first_name }} {{ children.last_name }}
          </h5>
          <DetailSectionRowLayout
            :modelData="children"
            :listFields="listChildrenFields"
            :listExcludeFields="['first_name', 'last_name']"
          />
        </div>
        <hr style="margin-bottom: 0;" />
      </template>
    </DetailSectionRowLayout>
  </div>
</template>

<script>
import DetailSectionRowLayout from "../../common/DetailSectionRowLayout";
import { SERVICE_TYPE } from "../../../constants/employer";

export default {
  components: {
    DetailSectionRowLayout
  },
  props: ["user"],
  computed: {
    listChildrenFields() {
      if (this.user.selector1 === SERVICE_TYPE.NEW_BORN) {
        return this.$store.getters.childrenListFieldsNewBorn;
      } else if (this.user.selector1 === SERVICE_TYPE.SITTER) {
        return this.$store.getters.childrenListFieldsSitter;
      } else if (this.user.selector1 === SERVICE_TYPE.NANNY) {
        return this.$store.getters.childrenListFieldsNanny;
      } else if (this.user.selector1 === SERVICE_TYPE.PRIVATE_EDUCATOR) {
        return this.$store.getters.childrenListFieldsPrivateEducator;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/employers/applications/ApplicationView.vue